import { render, staticRenderFns } from "./cDocumentExternal.vue?vue&type=template&id=56eb4273&scoped=true"
import script from "./cDocumentExternal.vue?vue&type=script&lang=js"
export * from "./cDocumentExternal.vue?vue&type=script&lang=js"
import style0 from "./cDocumentExternal.vue?vue&type=style&index=0&id=56eb4273&prod&scoped=true&lang=css"
import style1 from "./cDocumentExternal.vue?vue&type=style&index=1&id=56eb4273&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56eb4273",
  null
  
)

export default component.exports